import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {User} from "../../user/user";
import {AuthService} from "../../auth/auth.service";


@Component({
    selector: 'db-email-verification',
    templateUrl: 'email-verification.component.html',
    styleUrls: ['email-verification.component.scss'],
    standalone: false
})
export class EmailVerificationComponent extends DialogComponent<null, boolean> implements OnInit {
  public loading: boolean;
  public emailSent: boolean = false;
  public serverErrors: any;
  @Input() user?: User;
  @Input() type: string;

  constructor(
    private _dialogService: DialogService,
    private _authService: AuthService,
  ) {
    super(
      _dialogService
    );

  }

  ngOnInit() {
  }

  public closeDialog(): void {
    if (this.type === 'fromSuccess') {
      this.result = true;
    }
    this.close();
  }

  public resendEmail(): void {
    this.emailSent = true;
    this._authService.resendVerificationEmail();
  }


}
